<template>
  <b-card no-body>
    <b-card-header>云盘挂载</b-card-header>
    <b-card-body>
      <b-table-simple hover responsive>
        <b-thead>
          <b-tr>
            <b-th>path</b-th>
            <b-th>funcName</b-th>
            <b-th>password</b-th>
            <b-th>spConfig</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="e in drive_map" :key="e.path">
            <b-td>{{ e.path }}</b-td>
            <b-td>{{ e.funcName }}</b-td>
            <b-td>
              <template v-if="e.password">{{ e.password }}</template>
              <span v-else>none</span>
            </b-td>
            <b-td>
              <b-icon
                icon="info-circle"
                scale="1.25"
                variant="primary"
                style="cursor: pointer"
                @click="showDriveInfo(e.path)"
              ></b-icon>
              <b-icon
                icon="x-circle"
                scale="1.25"
                variant="primary"
                style="cursor: pointer;margin-left: 8px;"
                @click="removeDrive(e.path)"
              ></b-icon>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <b-button
        variant="primary"
        :disabled="waiting"
        style="min-width: 80px;"
        v-b-modal.drive-add-modal
      >添加</b-button>
      <b-button
        href="#"
        variant="primary"
        :disabled="waiting"
        style="min-width: 80px;"
        class="ml-3"
        @click="save"
      >{{waiting?"提交中":"保存"}}</b-button>
    </b-card-body>

    <b-modal id="drive-add-modal" centered hide-footer title="Add New Drive" size="xl">
      <div>
        <div class="d-flex">
          <b-form-group label="映射路径" class="col-4">
            <b-form-input v-model="tmp_config.path"></b-form-input>
          </b-form-group>
          <b-form-group label="云盘密码" class="col-4">
            <b-form-input v-model="tmp_config.password"></b-form-input>
          </b-form-group>
          <b-form-group label="模块类型" class="col-4">
            <b-form-select v-model="selected" :options="funcNames"></b-form-select>
          </b-form-group>
        </div>
        <hr />

        <div v-show="selected==='onedrive_graph'">
          <div class="d-flex">
            <b-form-group label="根路径(root)" class="col-4">
              <b-form-input v-model="tmp_config.onedrive_graph.root"></b-form-input>
            </b-form-group>
            <b-form-group label="认证类型(默认为0,世纪互联为1)" class="col-4">
              <b-form-input v-model="tmp_config.onedrive_graph.oauth"></b-form-input>
            </b-form-group>
            <b-form-group label="获取令牌" class="col-4">
              <a
                class="btn btn-secondary d-block"
                href="https://point.onesrc.cn/oauth2/"
                target="blank"
              >GetToken</a>
            </b-form-group>
          </div>
          <b-form-group label="认证令牌(refresh_token)" class="col-12">
            <b-form-textarea
              rows="3"
              max-rows="8"
              v-model="tmp_config.onedrive_graph.refresh_token"
            ></b-form-textarea>
          </b-form-group>
        </div>

        <div v-show="selected==='onedrive_sharepoint'">
          <div class="d-flex">
            <b-form-group label="根路径" class="col-4">
              <b-form-input v-model="tmp_config.onedrive_sharepoint.root"></b-form-input>
            </b-form-group>
            <b-form-group label="分享链接" class="col-8">
              <b-form-input v-model="tmp_config.onedrive_sharepoint.shareUrl" type="url"></b-form-input>
            </b-form-group>
          </div>
        </div>

        <div v-show="selected==='gdrive_goindex'">
          <div class="d-flex">
            <b-form-group label="goindex密码" class="col-4">
              <b-form-input v-model="tmp_config.gdrive_goindex.password"></b-form-input>
            </b-form-group>
            <b-form-group label="cloudflare链接" class="col-8">
              <b-form-input v-model="tmp_config.gdrive_goindex.cfurl" type="url"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div v-show="selected==='linux_scf'">
          <div class="d-flex">
            <b-form-group label="根路径" class="col-4">
              <b-form-input v-model="tmp_config.linux_scf.root"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div v-show="selected==='system_phony'">
          <div class="d-flex">
            <b-form-group label="文件链接" class="col-12">
              <b-form-textarea
                rows="3"
                max-rows="8"
                v-model="tmp_config.system_phony.list"
                disabled
              ></b-form-textarea>
            </b-form-group>
          </div>
        </div>
        <hr />
        <b-button
          @click="addNewDrive"
          :disabled="!selected || !tmp_config.path"
          variant="primary"
          class="mx-3"
        >确认添加</b-button>
      </div>
    </b-modal>
    <b-modal id="drive-modal" centered hide-footer title="DriveInfo" size="xl">
      <pre><code>{{driveInfo}}</code></pre>
    </b-modal>
  </b-card>
</template>
<script>
export default {
  data() {
    return {
      waiting: false,
      drive_map: [{ path: "none" }],
      driveInfo: "no drive",
      funcNames: [
        "onedrive_graph",
        "onedrive_sharepoint",
        "gdrive_goindex",
        "linux_scf",
        "system_phony"
      ],
      selected: "",
      tmp_config: {
        path: "",
        onedrive_graph: {
          root: "",
          refresh_token: "",
          oauth: 0
        },
        onedrive_sharepoint: {
          root: "",
          shareUrl: ""
        },
        gdrive_goindex: {
          cfurl: "",
          password: ""
        },
        linux_scf: {
          root: ""
        },
        system_phony: {
          list: ""
        },
        password: ""
      }
    };
  },
  created: function() {
    let _this = this;
    this.common.axios
      .get("./admin/ajax/setting/drives")
      .then(res => {
        _this.drive_map = res.data.DRIVE_MAP;
      })
      .catch(err => {
        _this.drive_map = [{ path: "error: " + err.message }];
      });
  },
  methods: {
    showDriveInfo(path) {
      let m =
        this.drive_map.find(e => {
          return e.path === path;
        }) || "no such drive";
      this.driveInfo = JSON.stringify(m, null, 2);
      this.$bvModal.show("drive-modal");
    },
    removeDrive(path) {
      this.drive_map = this.drive_map.filter(e => {
        return e.path !== path;
      });
    },
    addNewDrive() {
      if (!this.tmp_config.path.endsWith("/"))
        return this.$message("格式有误,例如 /images/ ", "w");
      let exist = this.drive_map.find(e => {
        return e.path === this.tmp_config.path;
      });
      if (exist) return this.$message("该云盘已存在", "w");
      let obj = {
        path: this.tmp_config.path,
        funcName: this.selected,
        spConfig: JSON.parse(JSON.stringify(this.tmp_config[this.selected])),
        password: this.tmp_config.password,
        isNew: true
      };
      this.drive_map.push(obj);
      console.log(JSON.stringify(obj));
      this.$message("添加成功", "s");
      this.$bvModal.hide("drive-add-modal");
    },
    save() {
      let _this = this;
      this.waiting = true;
      let dm = JSON.parse(JSON.stringify(this.drive_map));
      let obj = {};
      dm.forEach(e => {
        obj[e.path] = e;
        delete e.path;
      });
      this.common.axios
        .post("./admin/ajax/save", { DRIVE_MAP: obj })
        .then(r => {
          _this.waiting = false;
          alert(r.data.info);
        })
        .catch(e => {
          _this.waiting = false;
          console.log(e);
          alert("failed");
        });
    }
  }
};
</script>